export default __webpack_public_path__ + "static/media/tfg-icon.bc00c064.svg";